import { render, staticRenderFns } from "./PlanBatchesForm.vue?vue&type=template&id=7fa5c91f&scoped=true"
import script from "./PlanBatchesForm.vue?vue&type=script&lang=js"
export * from "./PlanBatchesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa5c91f",
  null
  
)

export default component.exports